/**
 * @file
 * Kit upload dropzone with progress rows.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { el } = berTags.dom;
  const ui = Drupal.berUI;
  const { base } = ui.compose;

  // The upload dropzone with its progress rows; usable inside any popover.
  // The component reports loading while files are in flight.
  ui.upload = ({
    label = Drupal.t('Drop files here or click to upload'),
    multiple = true,
    accept = '',
    onFiles,
  } = {}) => {
    const root = el('div', 'ber-ui__upload');
    const drop = el('div', 'ber-upload__drop');
    drop.tabIndex = 0;
    drop.setAttribute('role', 'button');
    drop.textContent = label;
    const input = el('input', 'ber-upload__input');
    input.type = 'file';
    input.multiple = multiple;
    if (accept) {
      input.accept = accept;
    }
    const progress = el('ul', 'ber-upload__progress');
    root.append(drop, input, progress);

    const api = Object.assign(base(root), {
      drop,
      input,
      progress,
      row: (name) => components.progressRow(progress, name),
      clearProgress() {
        progress.textContent = '';
        return api;
      },
      setAccept(value) {
        if (value) {
          input.accept = value;
        } else {
          input.removeAttribute('accept');
        }
        return api;
      },
    });

    const pick = async (files) => {
      if (!files || !files.length || !onFiles) {
        return;
      }
      api.loading(true);
      try {
        await onFiles(files, api);
      } finally {
        api.loading(false);
      }
    };
    drop.addEventListener('click', () => input.click());
    drop.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        input.click();
      }
    });
    input.addEventListener('change', () => {
      pick(input.files);
      input.value = '';
    });
    ['dragover', 'dragenter'].forEach((type) =>
      drop.addEventListener(type, (event) => {
        event.preventDefault();
        drop.classList.add('is-dragover');
      }),
    );
    ['dragleave', 'drop'].forEach((type) =>
      drop.addEventListener(type, (event) => {
        event.preventDefault();
        drop.classList.remove('is-dragover');
      }),
    );
    drop.addEventListener('drop', (event) => {
      if (event.dataTransfer && event.dataTransfer.files.length) {
        pick(event.dataTransfer.files);
      }
    });
    ui.emit('upload', { component: api });
    return api;
  };

  ui.register('upload', ui.upload);
})(Drupal);
